const PERSON_ID_SPLIT_REGEX = /[,;\n\r]+/;

const normalizePersonIdValues = (value) => {
  if (Array.isArray(value)) {
    return value.map((entry) => String(entry ?? '').trim()).filter(Boolean);
  }

  if (typeof value === 'string') {
    return value
      .split(PERSON_ID_SPLIT_REGEX)
      .map((entry) => entry.trim())
      .filter(Boolean);
  }

  return [];
};

const getUniquePersonIdValues = (value) => Array.from(new Set(normalizePersonIdValues(value)));

const getUniquePersonIdCount = (value) => getUniquePersonIdValues(value).length;

const getPersonIdDisplayLabel = (value) => {
  const uniqueValues = getUniquePersonIdValues(value);

  if (uniqueValues.length === 0) {
    return '';
  }

  return uniqueValues.length === 1 ? '1 ID' : `${uniqueValues.length} IDs`;
};

const getDuplicatePersonIdValidationMessage = (value) => {
  const normalizedValues = normalizePersonIdValues(value);
  const uniqueCount = getUniquePersonIdCount(normalizedValues);
  const totalCount = normalizedValues.length;
  const excludedCount = totalCount - uniqueCount;

  if (excludedCount <= 0) {
    return '';
  }

  return `${uniqueCount} out of ${totalCount} Person IDs apply. ${excludedCount} values could not be matched and will be excluded.`;
};

export {
  normalizePersonIdValues,
  getUniquePersonIdValues,
  getUniquePersonIdCount,
  getPersonIdDisplayLabel,
  getDuplicatePersonIdValidationMessage,
};
